<template>
  <div class="checkout-container">
    <add-on-sale ref="addOnSale"
      :products="productsByCategory('Ekstra')"
    />
    <div class="progress-container">
      <a-steps progress-dot :current="current">
        <a-step title="Handlevogn" description="Gjennomgå ordren din" />
        <a-step title="Betaling" description="Siste steg!" />
        <a-step title="Bekreftelse" description="Dine ordredetaljer." />
      </a-steps>
    </div>
    <loading-card v-show="isLoading" />
    <div class="selected-restaurant" v-show="current==0"><h2>Valgt restaurant:</h2><h3>{{selectedRestaurant.replace("AS", "")}}</h3></div> 
    <div class="checkout-wrapper" v-show="!isLoading">

      <CartView @itemInCartRemoved="handleItemInCartRemovedEvent"
                @itemInCartQuantityUpdated="handleItemInCartQuantityChangedEvent"
                v-show="current==0"
      />
      <ConfirmationViewFormValidation ref="confirmView" v-show="current==0" @goToPaymentView="handleGoToPaymentViewRedirectEvent"/>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { LOADING_EVENT, UNLOADING_EVENT } from "../../events/eventsSource";
import CartView from "@/views/carts/CartView";
import ConfirmationViewFormValidation from "@/views/checkout/ConfirmationViewFormValidation";
import LoadingCard from "../../components/spinnings/LoadingCard.vue";
import AddOnSale from '../../components/modals/AddOnSale.vue'
import TimeFormatter from "../../commons/TimeFormatter";
import CustomerStorage from '../../storage/customer';
export default {

  inject: ["eventBus"],
  components: {
    CartView,
    ConfirmationViewFormValidation,
    LoadingCard,
    AddOnSale
  },
  props: {
    restaurantId: { type: Number },
    restaurantName: { type: String },
    address: { type: String },
    city: { type: String },
    postNumber: { type: Number },
    imageUrl: { type: String },
    fromTime: { type: String },
    toTime: { type: String },
    isClosed: { type: Boolean },
    phoneNumber: { type: String },
    inActive: { type: Boolean }
  },

  data() {
    return {
      menu: require("@/assets/images/calli-great.png"),
      thumbnail: require("@/assets/images/nr 20.jpg"),
      value: 1,
      isLoading: false,
      current: 0
    };
  },
  computed: {
    ...mapGetters({
      totalItems: "cart/itemsCount",
      productsByCategory: 'menus/productsByCategory'
    }),
    ...mapState({
      selectedRestaurant: state => state.app.selectedRestaurant
    }) },
  methods: {
    handleLoadingEvent() {
      this.isLoading = true;
    },
    handleUnloadingEvent() {
      this.isLoading = false;
    },
    handleUnregisterLoadingEvent() {
      this.isLoading = false;
    },
    handleItemInCartRemovedEvent() {
      this.$refs['confirmView'].resetEstimatedPickupTime();
    },
    handleItemInCartQuantityChangedEvent() {
      this.$refs['confirmView'].resetEstimatedPickupTime();
    },

    async handleGoToPaymentViewRedirectEvent() {
      console.log('Go To PaymentView Redirect');
      this.$loading(true);
      await this.$store.dispatch("restaurants/getCurrentLocalTimeAction");

      //
      // Check if the payment object is created, if not create payment object, otherwise update it
      //
      if (this.$store.state.payment.netsCheckoutOption === null) {
        let paymentInfo = {
          restaurantId: this.$store.state.restaurants.currentRestaurantId,
          amount: this.$store.getters["cart/totalPrice"] * 100,
          currency: "NOK",
          cart: this.$store.getters["cart/itemsInCart"],
          customerName: this.$store.state.cart.orderInfo.customerName,
          email: this.$store.state.cart.orderInfo.email.toLowerCase(),
          phoneNumber: this.$store.state.cart.orderInfo.phoneNumber.replace(/\s/g, ""),
          comment: this.$store.state.cart.orderInfo.comment,
          waitingTime: this.$store.state.cart.estimatedTime,
          pickupTime: TimeFormatter.timeToString(TimeFormatter.formatTime(this.$store.state.cart.orderInfo.pickupTime)),
          asap: this.$store.state.cart.orderInfo.asap
        };
        await this.$store.dispatch("payment/getNetsSessionTokenWithAnonymousOrderAction",paymentInfo);
      } else {
        let paymentInfo = {
          restaurantId: this.$store.state.restaurants.currentRestaurantId,
          paymentId: this.$store.state.payment.netsCheckoutOption.paymentId,
          amount: this.$store.getters["cart/totalPrice"] * 100,
          currency: "NOK",
          cart: this.$store.getters["cart/itemsInCart"],
          customerName: this.$store.state.cart.orderInfo.customerName,
          email: this.$store.state.cart.orderInfo.email.toLowerCase(),
          phoneNumber: this.$store.state.cart.orderInfo.phoneNumber.replace(/\s/g, ""),
          comment: this.$store.state.cart.orderInfo.comment,
          waitingTime: this.$store.state.cart.estimatedTime,
          pickupTime: TimeFormatter.timeToString(TimeFormatter.formatTime(this.$store.state.cart.orderInfo.pickupTime)),
          asap: this.$store.state.cart.orderInfo.asap
        };
        await this.$store.dispatch("payment/updateNetsSessionTokenWithAnonymousOrderAction", paymentInfo);
      }

      let paymentId = this.$store.state.payment.netsCheckoutOption.paymentId;
      this.$router.push({
        name: 'payment',
        // query: { paymentId : this.$store.state.payment.netsCheckoutOption.paymentId } 
        query: { paymentId: paymentId } 
      });
      this.$loading(false)
    },

    async handleGoToPaymentViewEvent() { 
      //
      // store cart in local storage
      //
      // let currentRestaurantId = this.$store.state.restaurants.currentRestaurantId;
      // let itemsInCart = this.$store.state.cart.selectedItems;
      // RestaurantStorage.storeCurrentRestaurant(currentRestaurantId);
      // CartStorage.storeCart(currentRestaurantId, itemsInCart);
      console.log('Go To PaymentView')
      //
      // create payment
      //
      this.$loading(true);
      if (this.$store.state.payment.netsCheckoutOption === null) {
        console.log('Create payment')
        await this.$store.dispatch("restaurants/getCurrentLocalTimeAction");
        let paymentInfo = {
          restaurantId: this.$store.state.restaurants.currentRestaurantId,
          amount: this.$store.getters["cart/totalPrice"] * 100,
          currency: "NOK",
          cart: this.$store.getters["cart/itemsInCart"],
          customerName: this.$store.state.cart.orderInfo.customerName,
          email: this.$store.state.cart.orderInfo.email.toLowerCase(),
          phoneNumber: this.$store.state.cart.orderInfo.phoneNumber.replace(/\s/g, ""),
          comment: this.$store.state.cart.orderInfo.comment,
          waitingTime: this.$store.state.cart.estimatedTime,
          pickupTime: TimeFormatter.timeToString(TimeFormatter.formatTime(this.$store.state.cart.orderInfo.pickupTime)),
          asap: this.$store.state.cart.orderInfo.asap
        };
        console.log(paymentInfo)
        await this.$store.dispatch("payment/getNetsSessionTokenWithAnonymousOrderAction",paymentInfo);
        this.$refs['paymentView'].initPayment();
      } else {
        console.log('Update payment')
        this.$refs['paymentView'].preUpdatePayment();
        let paymentInfo = {
          restaurantId: this.$store.state.restaurants.currentRestaurantId,
          paymentId: this.$store.state.payment.netsCheckoutOption.paymentId,
          amount: this.$store.getters["cart/totalPrice"] * 100,
          currency: "NOK",
          cart: this.$store.getters["cart/itemsInCart"],
          customerName: this.$store.state.cart.orderInfo.customerName,
          email: this.$store.state.cart.orderInfo.email.toLowerCase(),
          phoneNumber: this.$store.state.cart.orderInfo.phoneNumber.replace(/\s/g, ""),
          comment: this.$store.state.cart.orderInfo.comment,
          waitingTime: this.$store.state.cart.estimatedTime,
          pickupTime: TimeFormatter.timeToString(TimeFormatter.formatTime(this.$store.state.cart.orderInfo.pickupTime)),
          asap: this.$store.state.cart.orderInfo.asap
        };
        await this.$store.dispatch("payment/updateNetsSessionTokenWithAnonymousOrderAction",paymentInfo);
        this.$refs['paymentView'].updatePayment();
      }
      this.$loading(false);
      this.current = 1;
    },
    handleBackToCartEventClicked() {
      this.current = 0;
    },
    showModal() {
      this.$modal.show("add-on-sale");
    }
  },
  created() {
    console.log('checkout view is created')

    //
    // load customer info
    //
    let customer = CustomerStorage.getCustomerInfo();
    let comment = CustomerStorage.getComment();
    if (customer !== null || Object.keys(customer) > 0) {
      this.$store.commit('cart/SET_CUSTOMER_INFO', customer);
      this.$store.commit('cart/SET_COMMENT_STATE', comment);
    }

    this.eventBus.$on(LOADING_EVENT, this.handleLoadingEvent);
    this.eventBus.$on(UNLOADING_EVENT, this.handleUnloadingEvent);
  },
  mounted() {
    this.showModal();
  },
  destroyed() {
    this.eventBus.$off(LOADING_EVENT, this.handleUnregisterLoadingEvent);
    this.eventBus.$off(UNLOADING_EVENT, this.handleUnregisterLoadingEvent);
  }
};
</script>

<style lang="scss" scoped>
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.cart-view-container{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.selected-restaurant{
  font-family: bebas;
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 50px ;
      display: flex;
    flex-direction: column;
    align-items: center;
     @media (max-width: $tablet) {

       margin-bottom: 9px;
  }
  & h3{
        border: 1px solid #e3e3e3;
    width: 14em;
    padding: 1.5em;
    background-color: whitesmoke;
    border-radius: 8px;
     @media (max-width: $tablet) {
    width: 54%;

       padding: 4%;
  }
  }
}
.progress-container {
  margin: 5% 25%;

  @media (max-width: $mobile) {
    margin: 10px 0 0 0;
    position: relative;
    left: -16px;
  }
}
.checkout-wrapper {
  display: flex;
  justify-content: center;

  @media (max-width: $mobile) {
    flex-direction: column;
    width: auto;
  }

    @media (width: 1024px) {
    margin: 0 21px
  }
}
.checkout-container {
  margin-bottom: 60px;
  font-family: Roboto, sans-serif;
}
.header-background-image {
  background-image: url("~@/assets/images/cartview-image.jpg");
  background-size: cover;

  margin-top: 10px;
  height: 490px;
  width: 100%;
  object-fit: cover;

  display: grid;
  place-items: center;
  @media (max-width: $mobile) {
    height: 200px;
    position: static;
    bottom: 0;
  }
}
.header-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 100px;
    width: 50%;
    border-radius: 30px;
  }
}
.about-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 40px;
    width: auto;
  }
}
h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400 !important;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
}
.about-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0 0 0.67em 0;
  font-size: 2vw;
  margin: 0;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
  }
}
</style>
